import React from "react";
import ReactDOM from "react-dom";

import NoSsr from "@material-ui/core/NoSsr";

import { APP_BAR_ID } from "../constants";

class TopBarPortalBase extends React.Component {
  public el = document.createElement("div");
  public modalRoot: any = null;

  public componentDidMount() {
    this.setState({ isMounted: true });
    this.modalRoot = document.getElementById(APP_BAR_ID);

    if (this.modalRoot) {
      this.modalRoot.appendChild(this.el);
    }
  }

  public componentWillUnmount() {
    this.modalRoot.removeChild(this.el);
  }

  public render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

const TopBarPortal: React.FC = ({ children }) => (
  <NoSsr>
    <TopBarPortalBase>{children}</TopBarPortalBase>
  </NoSsr>
);

export { TopBarPortal };
